module.exports = __webpack_public_path__ + "media/images/mattermost-7ba76903675adae35146920e92e35ba9.png";